import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import App from "./App.tsx";
import "./index.css";
import "katex/dist/katex.min.css";
import { AuthProvider } from "@/contexts/AuthProvider";

const STORAGE_VERSION_KEY = "ap-ace:storage-version";
const STORAGE_VERSION_VALUE = "2025-09-25"; // increment to invalidate prior local data

function ensureStorageVersion() {
	if (typeof window === "undefined" || typeof window.localStorage === "undefined") return;
	try {
		const existing = window.localStorage.getItem(STORAGE_VERSION_KEY);
		if (existing !== STORAGE_VERSION_VALUE) {
			window.localStorage.clear();
			window.localStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION_VALUE);
		}
	} catch (error) {
		console.warn("Failed to sync storage version", error);
	}
}

ensureStorageVersion();

const posthogOptions = {
	api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
	ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST || "https://us.posthog.com",
} as const;

createRoot(document.getElementById("root")!).render(
	<PostHogProvider
		apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
		options={posthogOptions}
	>
		<AuthProvider>
			<App />
		</AuthProvider>
	</PostHogProvider>
);
